/**
 * Community view — F13B social.
 * Redirects to Tailchat with SSO (portal session carries through).
 */

import { applyMembrane } from "../lib/api-clients";

export function CommunityView({ isOperator }: { isOperator: boolean }) {
  const communityUrl = import.meta.env.VITE_COMMUNITY_URL || "https://community.getrida.work";

  return (
    <div className="view">
      <div className="view-header">
        <span className="eyebrow">Social</span>
        <h1>Community</h1>
      </div>
      <div className="card">
        <div className="card-title">{applyMembrane("Your Community", isOperator)}</div>
        <p className="card-desc">
          Connect with other businesses using the platform. Share strategies, ask questions, and collaborate.
        </p>
        <a href={communityUrl} className="btn-primary" target="_blank" rel="noopener noreferrer">
          Open Community →
        </a>
      </div>
    </div>
  );
}
